<template>
  <v-menu
    ref="menu1"
    v-model="datemenu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model=dateFormatted
        :label=label
        :hint=hint
        :persistent-hint=persistentHint
        :prepend-icon=prependIcon
        @blur=handleBlur
       
        v-on=on
        outlined
        :hide-details=hideDetails
      ></v-text-field>
    </template>
    <v-date-picker :value=value no-title @input="datemenu = false"  @change=handleChange></v-date-picker>
  </v-menu>
</template>

<script>
export default {
  name: "Datepicker",
  props: ['onChange', 'value', 'hint', 'label', 'prependIcon', 'persistentHint', 'hideDetails'],
  data: () => ({
    datemenu: false,
  }),
  computed: {
    dateFormatted: {
      get: function () {
        return this.formatDate(new Date(this.value).toISOString())
      },
    },
  },
  methods: {
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.substr(0, 10).split('-');
      return `${month}/${day}/${year}`
    },
    parseDate (date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    handleBlur() {

    },
    handleChange(value) {
      if(this.onChange) this.onChange(value);
    }
  }
}
</script>

<style>

</style>